module.exports = __webpack_public_path__ + "static/media/chevron-left-dark.af6dd69d.svg";